import { Button, Divider, Space, Tooltip, Switch, Empty, Table, Select, Input } from 'antd'
import { useEffect, useMemo, useState, useCallback } from 'react'
import ReactECharts from 'echarts-for-react'
import styled from 'styled-components'
import {
  DeleteModal,
  ListPage,
  OptionType,
  SignTitle,
  SvgIcon,
  TableTag,
  IconFont,
} from '@/components'
import { ShowTotal } from '@/components/show-total'
import { FilterDropdownProps } from 'antd/lib/table/interface'
import '@/utils/echarts-wordcloud.min.js'
import EmptyImg from '@/assets/imges/Empty/Empty.png'
import bg from '@/assets/imges/站点分析.png'
import siteIcon from '@/assets/imges/站点.png'
import {
  useGetComponentFilter,
  useGetSiteCollectionList,
  useGetAutoUpdate,
  useGetSiteCollectionAutoUpdate,
  useGetSiteCollectionBatchSite,
  useGetSiteCollectionAnalyze,
} from './utils'
import { useDebounceFn } from 'ahooks'
import { t } from '@/i18n'

const SiteCollect = () => {
  const [batchAddVisible, setBatchAddVisible] = useState<{ id: any[]; visible: boolean }>({
    id: [],
    visible: false,
  })
  let [switchVisible, setSwitchVisible] = useState({ visible: false, switchStatus: '' })
  const [filterParams, setFilterParams] = useState<{
    limit: number
    page: number
    site: string
    defenseStatus?: number | string
    component?: string | string[]
    addStatus?: string
  }>({ limit: 10, page: 1, site: '' })
  const [selectedRowKeys, setSelectedRowKeys] = useState<any>([])

  const [siteList, getSiteList, siteListLoading] = useGetSiteCollectionList()
  const [componentList] = useGetComponentFilter()
  const [status, getStatus] = useGetAutoUpdate()
  const [data, getSiteCollectionAutoUpdate] = useGetSiteCollectionAutoUpdate()
  const [site, getSiteCollectionBatchSite] = useGetSiteCollectionBatchSite()
  const [analyzeData, getSiteCollectionAnalyze] = useGetSiteCollectionAnalyze()

  const [osSelectOpen, setOsSelectOpen] = useState(false)
  const [componentSelectOpen, setComponentSelectOpen] = useState(false)
  const [addStatusSelectOpen, setAddStatusSelectOpen] = useState(false)

  const getData = () => {
    setSelectedRowKeys([])
    getSiteList({
      ...filterParams,
      defenseStatus:
        filterParams.defenseStatus === 'WafDefenseStatusProtected'
          ? 1
          : filterParams.defenseStatus === 'WafDefenseStatusUnprotected'
          ? 2
          : filterParams.defenseStatus === 'WafDefenseStatusUnknown'
          ? 0
          : null,
    }).catch(_ => {})
  }
  console.log('siteList', siteList)
  useEffect(() => {
    getData()
  }, [filterParams])

  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    setFilterParams({
      ...filterParams,
      page: pagination.current,
      limit: pagination.pageSize,
      ...filters,
      defenseStatus: filters.defenseStatus?.length > 0 ? filters.defenseStatus[0] : null,
      addStatus: filters.addStatus?.length > 0 ? filters.addStatus[0] : null,
      component: filters.component?.length > 0 ? filters.component : null,
    })
  }

  // 使用 ahooks 的 useDebounceFn
  const { run: debouncedSearch } = useDebounceFn(
    (value: string) => {
      setFilterParams({
        ...filterParams,
        site: value,
        page: 1,
      })
    },
    { wait: 300 },
  )

  const columns = [
    {
      title: (
        <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {t('站点')}
        </div>
      ),

      dataIndex: 'site',
      width: 300,
      render: text => (
        <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          <Tooltip getPopupContainer={() => document.body} title={text}>
            {text}
          </Tooltip>
        </div>
      ),
    },
    {
      title: (
        <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {t('操作系统')}
        </div>
      ),
      dataIndex: 'osName',
      width: 150,
      render: text => (
        <div
          style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: 200 }}
        >
          <Tooltip getPopupContainer={() => document.body} title={text}>
            {text || '-'}
          </Tooltip>
        </div>
      ),
    },
    {
      title: (
        <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {t('数据库')}
        </div>
      ),

      dataIndex: 'dbName',
      width: 150,
      render: text => (
        <div
          style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: 200 }}
        >
          <Tooltip getPopupContainer={() => document.body} title={text}>
            {text || '-'}
          </Tooltip>
        </div>
      ),
    },
    {
      title: (
        <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {t('开发语言')}
        </div>
      ),

      dataIndex: 'language',
      width: 150,
      render: text => (
        <div
          style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: 200 }}
        >
          <Tooltip getPopupContainer={() => document.body} title={text}>
            {text || '-'}
          </Tooltip>
        </div>
      ),
    },
    {
      title: (
        <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {t('影响组件')}
        </div>
      ),

      dataIndex: 'component',
      width: 200,
      filteredValue: filterParams.component
        ? Array.isArray(filterParams.component)
          ? filterParams.component
          : [filterParams.component]
        : [],
      filterDropdown: (props: FilterDropdownProps) => {
        const safeSelectedKeys = Array.isArray(props.selectedKeys) ? props.selectedKeys : []
        return (
          <div style={{ padding: 8, width: 300 }}>
            <Select
              mode="multiple"
              maxTagCount={'responsive'}
              style={{ width: '100%' }}
              placeholder={t('请选择影响组件')}
              getPopupContainer={() => document.body as HTMLElement}
              dropdownClassName="table-filter-dropdown"
              value={safeSelectedKeys}
              open={componentSelectOpen}
              onDropdownVisibleChange={setComponentSelectOpen}
              onChange={value => {
                if (Array.isArray(value)) {
                  props.setSelectedKeys(value)
                  setFilterParams({
                    ...filterParams,
                    component: value.length > 0 ? value.map(v => String(v)) : undefined,
                  })
                } else {
                  props.setSelectedKeys([value])
                  setFilterParams({
                    ...filterParams,
                    component: [String(value)],
                  })
                }
              }}
              dropdownRender={menu => (
                <div style={{ marginBottom: '6px' }}>
                  {menu}
                  <Divider style={{ margin: '3px 0 6px 0' }} />
                  <Space
                    className="space-btn"
                    style={{ display: 'flex', justifyContent: 'flex-end' }}
                  >
                    <Button
                      type="default"
                      size="small"
                      style={{ letterSpacing: '-2px', padding: '0 12px' }}
                      onClick={() => {
                        props.clearFilters?.()
                        setComponentSelectOpen(false)
                        setFilterParams({
                          ...filterParams,
                          component: undefined,
                        })
                      }}
                    >
                      {t('重置')}
                    </Button>
                    <Button
                      type="primary"
                      size="small"
                      style={{ letterSpacing: '-2px', padding: '0 12px' }}
                      onClick={() => {
                        props.confirm()
                        setComponentSelectOpen(false)
                      }}
                    >
                      {t('确定')}
                    </Button>
                  </Space>
                </div>
              )}
              options={componentList.map(item => ({ label: item.name, value: item.id }))}
            />
          </div>
        )
      },
      filterIcon: (filtered: boolean) => (
        <Tooltip title={t('筛选')} getPopupContainer={() => document.body}>
          <FilterIcon type="icon-a-shaixuan1" $filtered={filtered} />
        </Tooltip>
      ),

      render: text => (
        <div
          style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: 200 }}
        >
          <Tooltip getPopupContainer={() => document.body} title={text}>
            {text || '-'}
          </Tooltip>
        </div>
      ),
    },
    {
      title: (
        <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {t('添加状态')}
        </div>
      ),

      width: 130,
      dataIndex: 'addStatus',
      filteredValue: filterParams.addStatus ? [filterParams.addStatus] : [],
      filterDropdown: (props: FilterDropdownProps) => {
        const safeSelectedKeys = Array.isArray(props.selectedKeys) ? props.selectedKeys : []
        return (
          <div style={{ padding: 8, width: 300 }}>
            <Select
              style={{ width: '100%' }}
              placeholder={t('请选择添加状态')}
              value={safeSelectedKeys}
              open={addStatusSelectOpen}
              getPopupContainer={() => document.body as HTMLElement}
              dropdownClassName="table-filter-dropdown"
              onDropdownVisibleChange={setAddStatusSelectOpen}
              onChange={value => {
                props.setSelectedKeys(Array.isArray(value) ? value : [value])
                setFilterParams({
                  ...filterParams,
                  addStatus: Array.isArray(value)
                    ? String(value[0] || '') || undefined
                    : String(value || '') || undefined,
                })
              }}
              dropdownRender={menu => (
                <div style={{ marginBottom: '6px' }}>
                  {menu}
                  <Divider style={{ margin: '3px 0 6px 0' }} />
                  <Space
                    className="space-btn"
                    style={{ display: 'flex', justifyContent: 'flex-end' }}
                  >
                    <Button
                      type="default"
                      size="small"
                      style={{ letterSpacing: '-2px', padding: '0 12px' }}
                      onClick={() => {
                        props.clearFilters?.()
                        setAddStatusSelectOpen(false)
                        setFilterParams({
                          ...filterParams,
                          addStatus: undefined,
                        })
                      }}
                    >
                      {t('重置')}
                    </Button>
                    <Button
                      type="primary"
                      size="small"
                      style={{ letterSpacing: '-2px', padding: '0 12px' }}
                      onClick={() => {
                        props.confirm()
                        setAddStatusSelectOpen(false)
                      }}
                    >
                      {t('确定')}
                    </Button>
                  </Space>
                </div>
              )}
              options={[
                { label: t('已添加'), value: 'AddStatusTrue' },
                { label: t('未添加'), value: 'AddStatusFalse' },
              ]}
              allowClear
            />
          </div>
        )
      },
      filterIcon: (filtered: boolean) => (
        <Tooltip title={t('筛选')} getPopupContainer={() => document.body}>
          <FilterIcon type="icon-a-shaixuan1" $filtered={filtered} />
        </Tooltip>
      ),

      render: record => (
        <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          <Tooltip
            getPopupContainer={() => document.body}
            title={record === 'AddStatusTrue' ? t('已添加') : t('未添加')}
          >
            {record === 'AddStatusTrue' ? (
              <span
                style={{
                  display: 'inline-block',
                  width: 42,
                  height: 18,
                  background: '#D6F4C7',
                  borderRadius: 4,
                  lineHeight: '18px',
                  fontSize: 12,
                  textAlign: 'center',
                  color: '#5BC825',
                }}
              >
                {t('已添加')}
              </span>
            ) : (
              <span
                style={{
                  display: 'inline-block',
                  width: 42,
                  height: 18,
                  background: '#D9D9D9',
                  borderRadius: 4,
                  lineHeight: '18px',
                  fontSize: 12,
                  textAlign: 'center',
                  color: '#333333',
                }}
              >
                {t('未添加')}
              </span>
            )}
          </Tooltip>
        </div>
      ),
    },
    {
      title: (
        <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {t('操作')}
        </div>
      ),

      width: 80,
      fixed: 'right' as const,
      render: (_, record) => (
        <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          <Space split={<Divider type={'vertical'} style={{ margin: '0 4px' }} />}>
            <div
              style={{ color: '#1b2b53', display: 'flex', alignItems: 'center', cursor: 'pointer' }}
              onClick={() => {
                if (record?.addStatus !== 'AddStatusTrue') {
                  setBatchAddVisible({ visible: true, id: [record.id] })
                }
              }}
            >
              {record?.addStatus === 'AddStatusTrue' ? (
                '-'
              ) : (
                <Button type="default" className="add-btn">
                  {t('添加')}
                </Button>
              )}
            </div>
          </Space>
        </div>
      ),
    },
  ]

  const wafCover = useMemo(() => {
    const obj = analyzeData?.wafCover
    const resultArray: Array<{ name: string; value: any; id?: string }> = []
    for (const key in obj) {
      // 检查属性是否属于对象自身（而不是从原型链上继承的）
      if (obj.hasOwnProperty(key) && obj[key] !== null) {
        // 将键和值作为对象 { name: key, value: obj[key] } 添加到数组中
        resultArray.push({ name: key, value: obj[key] })

        // 根据特定键名修改 name 属性的值（可选）
        if (key === 'protectedCount') {
          resultArray[resultArray.length - 1].name = t('WAF防护（有）')
          resultArray[resultArray.length - 1].id = 'protectedCount'
        } else if (key === 'unknownCount') {
          resultArray[resultArray.length - 1].name = t('WAF防护（未知）')
          resultArray[resultArray.length - 1].id = 'unknownCount'
        } else if (key === 'unprotectedCount') {
          resultArray[resultArray.length - 1].name = t('WAF防护（无）')
          resultArray[resultArray.length - 1].id = 'unprotectedCount'
        }
      }
    }
    return resultArray
  }, [analyzeData?.wafCover])

  const option2 = () => ({
    tooltip: {
      trigger: 'item',
    },
    label: {
      position: 'outer',
      alignTo: 'edge',
      margin: 2,
      color: '#999',
    },
    color: ['#4C45B5', '#716ADD', '#C1BBEB'],
    series: [
      {
        type: 'pie',
        top: '0%',
        radius: ['40%', '70%'],
        data: wafCover,
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.2)',
          },
        },
      },
    ],
  })

  const colors = ['#B70001', '#FF4141', '#FFA70B', '#73A0FA', '#7EDA51']
  const levelToColor = {
    SiteLevelPoor: colors[0], // 差
    SiteLevelFair: colors[1], // 较差
    SiteLevelAverage: colors[2], // 一般
    SiteLevelGood: colors[3], // 良好
    SiteLevelExcellent: colors[4], // 优秀
  }

  const levelPriority = {
    SiteLevelPoor: 1,
    SiteLevelFair: 2,
    SiteLevelAverage: 3,
    SiteLevelGood: 4,
    SiteLevelExcellent: 5,
  }

  const option3 = () => ({
    tooltip: {
      trigger: 'item',
    },
    label: {
      position: 'outer',
      alignTo: 'edge',
      margin: 2,
      color: '#999',
    },
    series: [
      {
        type: 'pie',
        top: '0%',
        radius: ['40%', '70%'],
        data: analyzeData?.levelList
          ?.sort((a, b) => levelPriority[a.level] - levelPriority[b.level]) // 根据优先级排序
          .map(item => {
            let color
            let name
            if (item.level === 'SiteLevelExcellent') {
              color = levelToColor.SiteLevelExcellent
              name = t('优秀')
            } else if (item.level === 'SiteLevelGood') {
              color = levelToColor.SiteLevelGood
              name = t('良好')
            } else if (item.level === 'SiteLevelAverage') {
              color = levelToColor.SiteLevelAverage
              name = t('一般')
            } else if (item.level === 'SiteLevelFair') {
              color = levelToColor.SiteLevelFair
              name = t('较差')
            } else {
              color = levelToColor.SiteLevelPoor
              name = t('差')
            }
            return {
              value: item.count,
              name: name,
              itemStyle: { color: color, label: { show: false } },
            }
          }),
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.2)',
          },
        },
      },
    ],
  })

  const arr = [
    '#4C45B5',
    '#73A0FA',
    '#558492',
    '#4FAAA8',
    '#3FBAD3',
    '#7AC0BD',
    '#FCB138',
    '#37AE78',
    '#2090A8',
    '#69C8EE',
    '#EB7E66',
    '#4C45B5',
    '#73A0FA',
    '#558492',
    '#4FAAA8',
    '#3FBAD3',
    '#7AC0BD',
    '#FCB138',
    '#37AE78',
    '#2090A8',
    '#69C8EE',
    '#EB7E66',
  ]

  const option4 = useMemo(
    () => ({
      animation: true,
      tooltip: {},
      series: [
        {
          type: 'wordCloud',
          width: '95%',
          height: '95%',
          sizeRange: [12, 20],
          rotationRange: [0, 0],
          shape: 'star',
          drawOutOfBound: true,
          textStyle: {
            color: params => arr[params?.dataIndex],
            emphasis: {
              shadowBlur: 10,
              shadowColor: '#333',
            },
          },
          data: analyzeData?.siteComponent?.map(item => ({
            name: item.componentName,
            id: item.componentId,
            value: Number(item.count),
          })),
        },
      ],
    }),
    [analyzeData?.siteComponent],
  )

  const onStatusClick = useCallback(
    name => {
      // 根据点击的饼图项设置对应的WAF防护状态
      let defenseStatus
      if (name?.data?.id === 'protectedCount') {
        defenseStatus = 'WafDefenseStatusProtected'
      } else if (name?.data?.id === 'unprotectedCount') {
        defenseStatus = 'WafDefenseStatusUnprotected'
      } else {
        defenseStatus = 'WafDefenseStatusUnknown'
      }

      // 更新过滤参数
      setFilterParams({
        ...filterParams,
        defenseStatus,
        page: 1, // 重置到第一页
      })
    },
    [filterParams],
  )

  const onTop10Click = useCallback(
    name => {
      setFilterParams({
        ...filterParams,
        component: [name?.data?.id],
        page: 1, // 重置到第一页
      })
    },
    [filterParams],
  )

  return (
    <div style={{ height: '100%', padding: 16 }}>
      {/* <AnalysisBox>
        <div className="analysis-box">
          <div className="title">{t("外部站点分析")}</div>
          <div
            className="site-total"
            style={{
              background: `no-repeat url(${bg})`,
              backgroundSize: '100% 100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexDirection: 'row'
            }}>

            <div
              style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>

              <div className="total-title">{t("站点总数")}</div>
              <div
                className="total"
                style={{ fontSize: '20px', display: 'flex', alignItems: 'center', marginTop: 15 }}>

                <span style={{ fontSize: '24px' }}>
                  {analyzeData?.externalSite?.totalSiteCount}
                </span>
                {t("个")}
              </div>
            </div>
            <div
              style={{
                marginRight: 8,
                marginTop: 40,
                width: 47,
                height: 50,
                background: `no-repeat url(${siteIcon})`,
                backgroundSize: '100% 100%'
              }} />

          </div>
          <div className="add-total">
            <div className="title">{t("已添加总数")}</div>
            <div
              style={{ color: '#677280', fontSize: '16px', display: 'flex', alignItems: 'center' }}>

              <span style={{ fontSize: '20px', fontWeight: 600, color: '#333333' }}>
                {analyzeData?.externalSite?.addSiteCount}
              </span>
              {t("个")}
            </div>
          </div>
          <div className="validate-total">
            <div className="title">{t("验证站点总数")}</div>
            <div
              style={{ color: '#677280', fontSize: '16px', display: 'flex', alignItems: 'center' }}>

              <span style={{ fontSize: '20px', fontWeight: 600, color: '#333333' }}>
                {analyzeData?.externalSite?.verifySiteCount}
              </span>
              {t("个")}
            </div>
          </div>
        </div>
        <div className="waf-cover">
          <div className="title">{t("WAF覆盖分布")}</div>
          <div className="chart">
            {wafCover?.length > 0 ?
            <ReactECharts
              onEvents={{
                click: onStatusClick
              }}
              style={{ height: '90%', width: '100%' }}
              option={option2()} /> :


            <Empty image={EmptyImg} imageStyle={{ marginTop: '60px' }} />
            }
          </div>
        </div>
        <div className="waf-protect">
          <div className="title">{t("WAF防护能力分布")}</div>
          <div className="chart">
            {analyzeData?.levelList?.length > 0 ?
            <ReactECharts style={{ height: '90%', width: '100%' }} option={option3()} /> :

            <Empty image={EmptyImg} imageStyle={{ marginTop: '60px' }} />
            }
          </div>
        </div>
        <div className="top20">
          <div className="title">{t("组件TOP20")}</div>
          <div className="chart">
            {analyzeData?.siteComponent?.length > 0 ?
            <ReactECharts
              style={{ height: '90%', width: '100%' }}
              option={option4}
              theme="ThemeStyle"
              onEvents={{
                click: onTop10Click
              }} /> :


            <Empty image={EmptyImg} imageStyle={{ marginTop: '60px' }} />
            }
          </div>
        </div>
      </AnalysisBox> */}
      <TableBox>
        <div className="filter-box">
          <div className="filter-title">
            {t('站点列表')}{' '}
            <span style={{ fontSize: 14, color: '#666', marginLeft: 10 }}>
              {t('最近更新时间：')}
              {siteList?.lastUpdateTime}
            </span>
          </div>
          <div className="filter-content">
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <Input
                placeholder={t('请输入站点名称')}
                prefix={<IconFont type="icon-sousuo1" style={{ color: '#666', fontSize: 16 }} />}
                allowClear
                onChange={e => debouncedSearch(e.target.value)}
                style={{ width: 250 }}
              />
              {t('同步配置：')}

              <Switch
                checkedChildren={t('开')}
                unCheckedChildren={t('关')}
                checked={status?.switchStatus === 'SwitchStatusOn'}
                onChange={e => {
                  setSwitchVisible({
                    visible: true,
                    switchStatus: e ? 'SwitchStatusOn' : 'SwitchStatusOff',
                  })
                }}
                style={{ marginRight: '10px' }}
              />

              <Tooltip
                title={t('开启后可联动同步外部攻击面系统web应用数据')}
                style={{ display: 'flex', alignItems: 'center' }}
                placement="topLeft"
              >
                <SvgIcon name={t('提示')} style={{ width: '16px', height: '16px' }} />
              </Tooltip>
            </div>
          </div>
        </div>
        <div>
          {selectedRowKeys.length > 0 && (
            <div
              style={{
                marginBottom: 16,
                background: '#F5F5FF',
                padding: '8px 16px',
                borderRadius: '6px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Space split={<Divider type="vertical" />}>
                <div>
                  {t('已选择')} {selectedRowKeys.length} {t('项')}
                </div>
                <Transfer
                  onClick={() => {
                    setBatchAddVisible({ visible: true, id: selectedRowKeys })
                  }}
                >
                  <SvgIcon name={'batch-config'} />
                  <span>{t('批量添加')}</span>
                </Transfer>
              </Space>
              <div
                onClick={() => {
                  setSelectedRowKeys([])
                }}
                style={{ cursor: 'pointer', color: '#666666' }}
                className="close-btn"
              >
                <IconFont type="icon-guanbi" style={{ fontSize: 12 }} />
              </div>
            </div>
          )}
          <Table
            rowKey="id"
            columns={columns}
            dataSource={siteList?.list}
            loading={siteListLoading}
            scroll={{ x: 1500 }}
            pagination={{
              total: siteList?.total,
              current: filterParams.page,
              pageSize: filterParams.limit,
              showTotal: t => <ShowTotal> {t} </ShowTotal>,
              pageSizeOptions: ['10', '20', '30', '40', '50'],
              showSizeChanger: true,
              showQuickJumper: true,
            }}
            onChange={handleTableChange}
            rowSelection={{
              selectedRowKeys,
              onChange: keys => {
                setSelectedRowKeys(keys)
              },
              getCheckboxProps: (record: any) => ({
                disabled: record.addStatus === 'AddStatusTrue',
              }),
            }}
          />
        </div>
      </TableBox>
      <DeleteModal
        onOk={() => {
          getSiteCollectionAutoUpdate({ switchStatus: switchVisible.switchStatus })
            .then(() => {
              getStatus().catch(_ => {})
            })
            .catch(_ => {})
          setSwitchVisible({ visible: false, switchStatus: '' })
        }}
        visible={switchVisible.visible}
        title={<SignTitle show>{t('提示')}</SignTitle>}
        text={t('此操作将更改同步配置状态，是否继续?')}
        onCancel={() => {
          setSwitchVisible({ visible: false, switchStatus: '' })
        }}
      />

      <DeleteModal
        onOk={() => {
          getSiteCollectionBatchSite({ id: batchAddVisible.id })
            .then(() => {
              setSelectedRowKeys([])
              setBatchAddVisible({ visible: false, id: [] })
              setFilterParams({ ...filterParams, page: 1, limit: 10 })
              getSiteCollectionAnalyze().catch(_ => {})
            })
            .catch(_ => {})
        }}
        visible={batchAddVisible.visible}
        title={<SignTitle show>{t('提示')}</SignTitle>}
        text={t('确认将该站点添加到站点资源列表，添加后即可进行任务下发?')}
        onCancel={() => {
          setBatchAddVisible({ visible: false, id: [] })
        }}
      />
    </div>
  )
}

export default SiteCollect

const AnalysisBox = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  .title {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    line-height: 24px;
    text-align: left;
    font-style: normal;
  }
  .analysis-box {
    flex: 1;
    height: 320px;
    background: #fff;
    border-radius: 8px;
    display: flex;
    padding: 20px 20px 0;
    flex-direction: column;
    margin-right: 16px;
    .site-total {
      width: 100%;
      height: 100px;
      padding: 16px 0 16px 20px;
      margin-top: 20px;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      flex-direction: column;
      .total-title {
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 500;
        font-size: 16px;
        color: #ffffff;
        line-height: 24px;
        text-align: left;
        font-style: normal;
      }
      .total {
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 500;
        font-size: 24px;
        color: #ffffff;
        line-height: 36px;
        text-align: left;
        font-style: normal;
      }
    }
    .add-total {
      border-bottom: 1px solid #d5d9dd;
      height: 80px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title {
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        line-height: 21px;
        text-align: left;
        font-style: normal;
        padding-left: 12px;
        position: relative;

        &::before {
          content: '';
          display: inline-block;
          width: 4px;
          height: 26px;
          background: #2090a8;
          position: absolute;
          left: 0;
          top: -1px;
        }
      }
    }
    .validate-total {
      height: 80px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title {
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        line-height: 21px;
        text-align: left;
        font-style: normal;
        padding-left: 12px;
        position: relative;

        &::before {
          content: '';
          display: inline-block;
          width: 4px;
          height: 26px;
          background: #fdce34;
          position: absolute;
          left: 0;
          top: -1px;
        }
      }
    }
  }
  .waf-cover {
    flex: 1;
    height: 320px;
    background: #fff;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    margin-right: 16px;
    padding: 16px 20px;
    .chart {
      height: 100%;
    }
  }
  .waf-protect {
    flex: 1;
    height: 320px;
    background: #fff;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    margin-right: 16px;
    padding: 16px 20px;
    .chart {
      height: 100%;
    }
  }
  .top20 {
    flex: 1;
    height: 320px;
    background: #fff;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    padding: 16px 20px;
    .chart {
      height: 100%;
    }
  }
`

const TableBox = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  .ant-space {
    gap: 0 !important;

    &.space-btn .ant-space-item {
      margin-right: 8px !important;
    }
  }
  .ant-btn-link {
    padding: 6.6px 0;
  }

  .ant-table-measure-row {
    display: none;
  }
  .ant-table-column-sorters {
    justify-content: flex-start;
    .ant-table-column-sorter {
      padding-top: 4px;
      margin-left: 5px;
    }
    .ant-table-column-title {
      flex: none;
    }
  }

  .ant-table-filter-column {
    justify-content: flex-start;
    .ant-table-column-title {
      flex: none;
    }
  }
  .filter-box {
    margin-bottom: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .filter-title {
      font-size: 16px;
      font-weight: 500;
    }
    .filter-content {
      display: flex;
      align-items: center;
    }
  }
  .close-btn {
    cursor: pointer;
    color: #666666;
    padding: 2px 4px;
    :hover {
      background: #ffffff;
      border-radius: 4px;
    }
  }

  .add-btn {
    width: 48px;
    height: 24px;
    border-radius: 4px;
    border: 1px solid #4238c9;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #4238c9;
    transition: 0.3s;

    &:hover {
      background: #4238c9;
      color: #fff;
    }
  }
`

const Transfer = styled.div`
  width: 91px;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  color: #333333;
  border-radius: 6px;
  display: flex;
  margin-right: 10px;
  align-items: center;
  cursor: pointer;
  justify-content: center;
  background-color: #f1f3f8;
  transition: 0.3s;
  font-weight: normal;
  &:hover {
    background-color: #ffffff;
  }
  svg {
    width: 16px;
    margin-right: 6px;
  }
`

const FilterIcon = styled(IconFont)<{ $filtered?: boolean }>`
  font-size: 14px;
  color: ${props => (props.$filtered ? '#4238C9' : '#999')};
  cursor: pointer;
  transition: color 0.3s;
  &:hover {
    color: #4238c9;
  }
`
